import BottomSheet from '@rio-cloud/rio-uikit/BottomSheet';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import { WhatsNewDescriptionItem } from '@/features/userManual/components/WhatsNew/WhatsNewPageDialogContent';
import { USER_MANUAL_TAB_PARAM } from '@/features/userManual/utils';
import { useWhatsNewStore } from '@/stores/whatsNewStore';

const WhatsNewBottomSheet = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { showBottomSheet, dismissBottomSheet, filteredWhatsNewData } = useWhatsNewStore();

    const content = filteredWhatsNewData[0]?.content;

    useEffect(() => {
        // If the bottom sheet is visible and the 'What's New' modal is open, close the bottom sheet.
        const activeTab = searchParams.get(USER_MANUAL_TAB_PARAM);
        if (showBottomSheet && activeTab === 'whatsNew') {
            dismissBottomSheet();
        }
    }, [showBottomSheet, searchParams]);

    const handleReadMore = () => {
        const params = new URLSearchParams(searchParams);
        params.set(USER_MANUAL_TAB_PARAM, 'whatsNew');
        navigate({ search: params.toString() });
        dismissBottomSheet();

        trackCustomEvent(
            'open_whatsNew',
            { trigger: 'click', flow_name: 'user_manual', element_name: 'click_on_read_more' },
            createDebugConfig()
        );
    };

    return (
        <BottomSheet
            show={showBottomSheet}
            width={400}
            onClose={dismissBottomSheet}
            detach
            bodyClassName='padding-25'
            data-test-id='bottom-sheet'
        >
            {content ? (
                <>
                    <div className='position-relative margin-top-15'>
                        <img
                            src={
                                content.isReleaseNotes
                                    ? '/whatsNew/bottomSheetNewFeature.webp'
                                    : '/whatsNew/bottomSheetNews.webp'
                            }
                            alt='Bottom sheet'
                            className='width-100pct height-100pct'
                        />
                        <div className='inset-0 margin-left-20 margin-top-20' style={{ height: '45px' }}>
                            <div className='display-flex height-100pct'>
                                <img
                                    src={
                                        content.isReleaseNotes
                                            ? '/whatsNew/bottomSheetNewFeatureIcon.webp'
                                            : '/whatsNew/bottomSheetNewsIcon.webp'
                                    }
                                    alt='Bottom sheet icon'
                                    className='margin-right-5'
                                />
                                <div className='display-flex flex-column'>
                                    <span
                                        className='text-color-white text-medium display-flex align-items-center'
                                        style={{ fontSize: '30px', height: '24px' }}
                                    >
                                        <FormattedMessage
                                            id={
                                                content.isReleaseNotes
                                                    ? 'bottomSheet.whatsNew.newFeature.title'
                                                    : 'bottomSheet.whatsNew.news.title'
                                            }
                                        />
                                    </span>
                                    <span className='text-color-white text-medium text-size-10 text-uppercase opacity-70 margin-top-10'>
                                        <FormattedMessage
                                            id={
                                                content.isReleaseNotes
                                                    ? 'bottomSheet.whatsNew.newFeature.subtitle'
                                                    : 'bottomSheet.whatsNew.news.subtitle'
                                            }
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='text-bold margin-top-10 margin-bottom-15'>
                        <FormattedMessage id={content.title} />
                    </div>
                    <div className='ellipsis-3'>
                        <WhatsNewDescriptionItem item={content.descriptionItems[0]} />
                    </div>
                    <div className='btn-toolbar margin-top-15 display-flex justify-content-end'>
                        <button type='button' className='btn btn-primary' onClick={handleReadMore}>
                            <span className='rioglyph rioglyph-detail-view-info' aria-hidden='true' />
                            <FormattedMessage id='bottomSheet.whatsNew.readMore' />
                        </button>
                    </div>
                </>
            ) : (
                <Spinner />
            )}
        </BottomSheet>
    );
};

export default WhatsNewBottomSheet;
